<template>
  <RF-Dialog :id="cpntHashId"
    :cpntStatus='statusGeral'
    :cpntLargura='"500px"'
    :cpntOnFecharDialog='venConfigIntermediadorFormFechar'>
    <template slot='titulo'>
      <!-- SETA O ICONE DO CAMPO -->
      <i aria-hidden="true" class="fa fa-angle-double-right"></i>

      <!-- SETA O TITULO DA ABA -->
      <template v-if="cpntId === 0 || cpntId.length === 1 && cpntId[0] === 0">Novo Intermediador</template>
      <template v-else-if="cpntId >= 1 || cpntId.length === 1 && cpntId[0] >= 1">
        <!-- SETA O TITULO DA ABA -->
        Edição do Intermediador - {{ cpntId >= 1 ? cpntId : cpntId[0] }}

        <!-- SETA OS DADOS DO PET EDITADO -->
        <div style="padding-left: 15px;" v-html="venConfigIntermediadorFormTituloDialog"></div>
      </template>
      <template v-else-if="cpntId.length >= 2">Editar Varios</template>
    </template>

    <template slot='conteudo'>
      <div class="ven-config-inter-form">
        <div>
          <App-Input :data-time="time" class="app-cpnt-field ven-config-inter-form--nome"
            :cpntStatus='campos.nome.status'
            :cpntId='campos.nome.id'
            :cpntClassDivField='campos.nome.classDivField'
            :cpntNome='campos.nome.nome'
            :cpntValue='campos.nome.value'
            :cpntAutoComplete='campos.nome.autocomplete'
            :cpntMask='campos.nome.mask'
            :cpntOptionInicialNome='campos.nome.optionInicialNome'
            :cpntOptionInicialValue='campos.nome.optionInicialValue'
            :cpntDisabled='campos.nome.disabled'
            :cpntMostrar='campos.nome.mostrar'
            :cpntAutoFocus='campos.nome.autofocus'
            :cpntMensagem='campos.nome.mensagem'
            :cpntMensagemTipo='campos.nome.mensagemTipo'
            :cpntPlaceholder='campos.nome.placeholder'
            :cpntPosicionar='campos.nome.posicionar'
            :cpntOnChange='campos.nome.onChange'
            :cpntOnBlur='campos.nome.onBlur'
            ref='nome'
          ></App-Input>

          <App-Input :data-time="time" class="app-cpnt-field ven-config-inter-form--cnpj"
            :cpntStatus='campos.cnpj.status'
            :cpntId='campos.cnpj.id'
            :cpntClassDivField='campos.cnpj.classDivField'
            :cpntNome='campos.cnpj.nome'
            :cpntValue='campos.cnpj.value'
            :cpntAutoComplete='campos.cnpj.autocomplete'
            :cpntMask='campos.cnpj.mask'
            :cpntOptionInicialNome='campos.cnpj.optionInicialNome'
            :cpntOptionInicialValue='campos.cnpj.optionInicialValue'
            :cpntDisabled='campos.cnpj.disabled'
            :cpntMostrar='campos.cnpj.mostrar'
            :cpntAutoFocus='campos.cnpj.autofocus'
            :cpntMensagem='campos.cnpj.mensagem'
            :cpntMensagemTipo='campos.cnpj.mensagemTipo'
            :cpntPlaceholder='campos.cnpj.placeholder'
            :cpntPosicionar='campos.cnpj.posicionar'
            :cpntOnChange='campos.cnpj.onChange'
            :cpntOnBlur='campos.cnpj.onBlur'
            ref='cnpj'
          ></App-Input>
        </div>

        <div>
          <App-Input :data-time="time" class="app-cpnt-field ven-config-inter-form--usu_intermediador"
            :cpntStatus='campos.usu_intermediador.status'
            :cpntId='campos.usu_intermediador.id'
            :cpntClassDivField='campos.usu_intermediador.classDivField'
            :cpntNome='campos.usu_intermediador.nome'
            :cpntValue='campos.usu_intermediador.value'
            :cpntAutoComplete='campos.usu_intermediador.autocomplete'
            :cpntMask='campos.usu_intermediador.mask'
            :cpntOptionInicialNome='campos.usu_intermediador.optionInicialNome'
            :cpntOptionInicialValue='campos.usu_intermediador.optionInicialValue'
            :cpntDisabled='campos.usu_intermediador.disabled'
            :cpntMostrar='campos.usu_intermediador.mostrar'
            :cpntAutoFocus='campos.usu_intermediador.autofocus'
            :cpntMensagem='campos.usu_intermediador.mensagem'
            :cpntMensagemTipo='campos.usu_intermediador.mensagemTipo'
            :cpntPlaceholder='campos.usu_intermediador.placeholder'
            :cpntPosicionar='campos.usu_intermediador.posicionar'
            :cpntOnChange='campos.usu_intermediador.onChange'
            :cpntOnBlur='campos.usu_intermediador.onBlur'
            ref='usu_intermediador'
          ></App-Input>
        </div>
      </div>
    </template>

    <template slot='rodape'>
      <div class="ven-config-inter-form-botoes">
        <App-Button
          :cpntStatus='botoes.cancelar.status' 
          :cpntId='botoes.cancelar.id' 
          :cpntTexto='botoes.cancelar.texto' 
          :cpntClass='botoes.cancelar.class'
          :cpntMostrar='botoes.salvar.mostrar'
          :cpntTabIndex='botoes.cancelar.tabIndex'
          @onClick='botoes.cancelar.onClick'
        ></App-Button>

        <App-Button
          :cpntStatus='botoes.salvar.status' 
          :cpntId='botoes.salvar.id' 
          :cpntTexto='botoes.salvar.texto' 
          :cpntClass='botoes.salvar.class'
          :cpntMostrar='botoes.salvar.mostrar'
          :cpntTabIndex='botoes.salvar.tabIndex'
          @onClick='botoes.salvar.onClick'
        ></App-Button>
      </div>
    </template>
  </RF-Dialog>
</template>

<style scoped>
.ven-config-inter-form {
  width: 100%;
  padding-top: 15px;
  text-align: left;
}
  .ven-config-inter-form > div:not(:first-child) {
    padding-top: 22px;
  }
  .ven-config-inter-form > div,
  .ven-config-inter-form > div > div {
    width: 100%;
  }
    .ven-config-inter-form > div > .ven-config-inter-form--nome {
      width: calc(65% - 10px);
      margin-right: 10px;
    }
    .ven-config-inter-form > div > .ven-config-inter-form--cnpj {
      width: 35%;
    }
  .ven-config-inter-form-botoes {
    text-align: right;
  }
    .ven-config-inter-form-botoes > button:not(:first-child) {
      margin-left: 5px;
    }
</style>

<style>
</style>

<script>
  export default {
    props: {
      cpntHashId: {
        required: false,
        default: function () {
          // INICIA A VARIAVEL ID
          var hash = ''

          // INICIA PARA VERIFICAR SE ENCONTROU UM ID
          var flag = false

          while (flag === false) {
            // GERA UM ID PARA O CAMPO
            hash = 'ven-config-inter-form-' + (Math.floor(Math.random() * (9999 - 1000)) + 1000).toString()

            // VERIFICA SE O ID GERADO É UNICO NA TELA
            flag = [ '', null, undefined ].indexOf(document.getElementById(hash)) !== -1
          }

          // RETONAR O VALOR MONTADO
          return hash
        }
      },
      cpntId: {
        required: false,
        default: function () {
          return 0
        }
      },
      cpntNomeDig: {
        required: false,
        type: [ String, Number ],
        default: function () {
          return ''
        }
      },
      cpntFecharFormulario: {
        required: false,
        default: function () {
          return null
        }
      }
    },
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando',
        campos: {
          nome: {
            id: this.cpntHashId + '--nome',
            status: '',
            nome: 'Nome',
            value: '',
            valueIni: '',
            apiEnv: 'nome',
            onChange: this.venConfigIntermediadorFormOnChangeValue
          },
          cnpj: {
            id: this.cpntHashId + '--cnpj',
            status: '',
            nome: 'CNPJ',
            value: '',
            valueIni: '',
            mask: 'cnpj',
            apiEnv: 'cnpj',
            onChange: this.venConfigIntermediadorFormOnChangeValue
          },
          usu_intermediador: {
            id: this.cpntHashId + '--usu_intermediador',
            status: '',
            nome: 'Usuário Intermediador',
            value: '',
            valueIni: '',
            apiEnv: 'usu_intermediador',
            onChange: this.venConfigIntermediadorFormOnChangeValue
          }
        },
        botoes: {
          cancelar: {
            status: '',
            id: this.cpntHashId + '-botoes--cancelar',
            texto: 'Cancelar',
            class: [ 'btn', 'btn-default', 'btn-sm' ],
            mostrar: true,
            onClick: () => { this.venConfigIntermediadorFormFechar(false) }
          },
          salvar: {
            status: '',
            id: this.cpntHashId + '-botoes--salvar',
            texto: 'Salvar',
            class: [ 'btn', 'btn-primary' ],
            mostrar: true,
            onClick: () => { this.venConfigIntermediadorFormSalvar() }
          },
        }
      }
    },
    mounted: function () {
      this.venConfigIntermediadorFormIniciar()
    },
    methods: {
      venConfigIntermediadorFormIniciar: function () {
        if (this.cpntId >= 1) {
          // SETA O STATUS DA PAGINA
          this.venConfigIntermediadorFormSetaStatusGeral('carregando')

          // BUSCA OS DADOS PARA O FORMULARIO
          this.venConfigIntermediadorFormBuscaDados(this.cpntId, (retorno) => {
            // PEGA O NOME DE CADA CHAVE QUE DEVE SETAR O VALOR
            var chaves = Object.keys(this.campos)

            // RODA O VETOR DOS CAMPOS
            for (var indexC in chaves) {
              // SETA O NOME DA CHAVE QUE SERÁ TRABALHADA
              var chave = chaves[indexC]

              // SETA OS VALORES DO CAMPO
              this.venConfigIntermediadorFormSetarValorCampo(chave, retorno)

              // SETA O VALOR INICIAL DO CAMPO
              this.campos[chave].valueIni = this.campos[chave].value
            }

            // SETA O STATUS DA PAGINA
            this.venConfigIntermediadorFormSetaStatusGeral('')

            // VERIFICA O CAMPO QUE DEVE REALIZAR O FOCUS
            this.venConfigIntermediadorFormRealizarFocusCampo('nome')
          })
        } else {
          // SETA O ID DO CONTATO RECEBIDO
          if ([ '', null, undefined ].indexOf(this.$route.params.id_con_nome) === -1 && [ '', null, undefined ].indexOf(this.$route.params.id_con) === -1) {
            this.campos.id_con.value = { id: this.$route.params.id_con, nome: this.$route.params.id_con_nome, empresa: '', cnpj_cpf: '' }
          }

          // SETA O NOME DIGITADO EM OUTRA TELA
          if ([ '', null, undefined ].indexOf(this.cpntNomeDig) === -1) {
            this.campos.nome.value = this.cpntNomeDig
          }

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
          
          // SETA O STATUS DA TELA
          this.venConfigIntermediadorFormSetaStatusGeral('')

          // VERIFICA O CAMPO QUE DEVE REALIZAR O FOCUS
          this.venConfigIntermediadorFormRealizarFocusCampo('nome')
        }
      },
      venConfigIntermediadorFormSetaStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      venConfigIntermediadorFormRealizarFocusCampo: function (campo, tentativa = 0) {
        if (tentativa <= 10) {
          // SETA A FUNÇÃO DE REINICIAR
          var reiniciar = () => { setTimeout(() => { this.venConfigIntermediadorFormRealizarFocusCampo(campo, (tentativa + 1)) }, 100) }

          // VERIFICA SE O CAMPO EXISTE
          if (tentativa >= 2 && [ '', null, undefined ].indexOf(this.$refs[campo]) === -1) {
            // PEGA O ELEMENTO QUE DEVE DAR FOCUS
            var elemento = Array.isArray(this.$refs[campo]) === true ? this.$refs[campo][0] : this.$refs[campo]

            // VERIFICA SE O ELEMENTO EXISTE
            if ([ '', null, undefined ].indexOf(elemento) === -1 && [ '', null, undefined ].indexOf(elemento.cpntRealizarFocus) === -1 && typeof elemento.cpntRealizarFocus === 'function') {
              elemento.cpntRealizarFocus()
            } else {
              reiniciar()
            }
          } else {
            reiniciar()
          }
        }
      },
      venConfigIntermediadorFormBuscaDados: function (id, callback) {
        // SETA O QUERY GET NA API
        var queryGet = { type: 'list', limit: { row: 0, qty: 1000 }, where: { f: 'id', o: '=', v: id } }

        // SETA OS CAMPOS QUE DEVE BUSCAR
        queryGet.field = {
          id: null,
          nome: null,
          cnpj: null,
          usu_intermediador: null,
          last_at: null,
          last_user: null
        }

        // COMUNICA COM A API
        this.$store.state.comunicaAPI('/venda/config/intermediador/get', 'POST', queryGet, function (retorno) {
          callback(retorno.data[0])
        }, this.venConfigIntermediadorFormSetaStatusGeral)
      },
      venConfigIntermediadorFormSetarValorCampo: function (chave, dados) {
        // INICIA A VARIAVEL DE VALOR
        var value = ''
        var valueRef = ''
        var options = null

        // VERIFICA O VALOR QUE DEVE SELECIONAR
        switch (chave) {
          case 'nome':
          case 'cnpj':
          case 'usu_intermediador':
            value = [ '', null, undefined ].indexOf(dados[chave]) === -1 ? dados[chave] : ''
            break
        }

        // PEGA OS OPTIONS DO CAMPO
        if (options === null && [ '', null, undefined ].indexOf(this.campos[chave].options) === -1 && this.campos[chave].options.length >= 1) {
          options = this.campos[chave].options
        }

        // VERIFICA SE TEM OPTION E O VALOR SELECIONADO É UM STRING
        if (options !== null && options.length >= 1 && typeof value === 'string') {
          // PEGA O VALOR DO CAMPO
          var valor = options.filter((option) => { return option[this.campos[chave].keyValue] === value })

          // SETA O VALOR ENCONTRADO
          value = valor.length === 1 ? valor[0] : value
        }

        // SETA O VALOR ATUALIZADO DO CAMPO
        this.$set(this.campos[chave], 'value', value)
        this.$set(this.campos[chave], 'valueRef', valueRef)

        // VERIFICA SE TEM VALOR PARA ATUALIZAR
        if (options !== null) {
          this.$set(this.campos[chave], 'options', options)
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      venConfigIntermediadorFormOnNovoContato: function (value) {
        // SETA OS PARAMETROS QUE SERÁ ENVIADO
        var params = { editar: false, tipo: 'contato', id: 0, nome: value }
        
        // VERIFICA SE FOI ENCONTRADO O NUMERO DO REGISTRO
        if ([ '', null, undefined ].indexOf(params.id) === -1) {
          // SETA O CALLBACK QUE DEVE EXECUTAR
          params.callback = (atualizar, id, dados) => {
            if (atualizar === true) {
              // CONVERTE AS CHAVES RECEBIDAS
              for (var indexD in dados) {
                dados['id_con_' + indexD] = dados[indexD]
              }
              
              // SETA OS DADOS DO CONTATO NO FORMULARIO
              this.venConfigIntermediadorFormSetarValorCampo('id_con', dados)
            }
          }

          // CHAMA A FUNÇÃO PARA INFORMAR QUE A ROTA FOI ATUALIZADA
          this.$store.commit('SET_ABRIR_CADASTRO_VET', params)
        }
      },
      venConfigIntermediadorFormOnChangeValue: function (value, id) {
        // PEGA O NOME DO CAMPO QUE ESTÁ SENDO ALTERADO
        var indexF = id.split('--')

        // SETA O VALOR RECEBIDO
        this.$set(this.campos[indexF[1]], 'value', value)

        // LIMPA O CAMPO DE MENSAGEM DE ERRO
        this.$set(this.campos[indexF[1]], 'mensagem', '')

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      venConfigIntermediadorFormSalvar: function () {
        // SETA OS VALORES RECEBIDOS
        this.$set(this.botoes.salvar, 'status', 'carregando')

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // SETA A FUNÇÃO PARA FINALIZAÇÃO DO PROCESSO
        const finalizacao = () => {
          // SETA OS VALORES RECEBIDOS
          this.$set(this.botoes.salvar, 'status', '')

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        }

        // IMPORTA A FUNÇÃO QUE SERÁ UTILIZADA
        const FUN_MONTAR_FORMDATA_API = require('@/assets/js/Funcoes-Gerais.js').FUN_MONTAR_FORMDATA_API

        // FAZ A VERIFICAÇÃO E MONTAGEM DO FORMULARIO
        FUN_MONTAR_FORMDATA_API(this.campos).then((formData) => {
          // INICIA A VARIAVEL
          var method = 'POST'

          // VERIFICA SE TEM AGUM REGISTRO PARA ATUALIZAR
          if (typeof this.cpntId === 'object' || this.cpntId !== 0) {
            // SETA O ID QUE DEVE ATUALIZAR
            formData.id = this.cpntId

            // SETA QUE SERÁ UMA ATUALIZAÇÃO
            method = 'PUT'
          }

          // REMOVE TUDO QUE NÃO FOR NUMERO
          if ([ '', null, undefined ].indexOf(formData.cnpj) === -1) {
            formData.cnpj = formData.cnpj.replace(/\D/g, '')
          }

          // CONVERTE O VALOR PARA LOTE
          formData = { lot: [ formData ] }

          // COMUNICA COM A API
          this.$store.state.comunicaAPI('/venda/config/intermediador', method, formData, (retorno) => {
            // PEGA O VALOR RECEBIDO
            retorno = retorno.lot[0]

            // VERIFICA SE DEU ERRO E RETORNA OS VALORES ORIGINAL DO CAMPO
            if (retorno.code !== '200') {
              this.venConfigIntermediadorFormTratarValidacao(retorno.message, retorno.code, finalizacao)
            } else {
              // APRESENTA A MENSAGEM DE SUCESSO
              this.$store.state.TRATAR_RET_LOT_API(retorno)
              
              // CHAMA A FUNÇÃO PARA FINALIZAR O PROCESSO
              this.venConfigIntermediadorFormFechar(true, [ '', null, undefined ].indexOf(retorno.ref) === -1 && [ '', null, undefined ].indexOf(retorno.ref.id) === -1 ? retorno.ref.id : this.cpntId)
            }
          }, this.venConfigIntermediadorFormSetaStatusGeral, (apiValid, apiStatus) => { this.venConfigIntermediadorFormTratarValidacao(apiValid, apiStatus, finalizacao) })
        })
      },
      venConfigIntermediadorFormTratarValidacao: function (apiValid, apiStatus = 400, callback = null) {
        // IMPORTA A FUNÇÃO QUE SERÁ UTILIZADA
        const FUN_TRATAR_VALIDACAO_API = require('@/assets/js/Funcoes-Gerais.js').FUN_TRATAR_VALIDACAO_API

        // FAZ A VERIFICAÇÃO E MONTAGEM DO FORMULARIO
        FUN_TRATAR_VALIDACAO_API(apiValid, apiStatus, this.campos, this).then(() => {
          // SETA O STATUS DE CARREGANDO DO BOTÃO
          this.botoes.salvar.status = ''

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
          
          // EXECUTA O CALLBACK RECEBIDO
          if (callback !== null && typeof callback === 'function') {
            callback()
          }
        })
      },
      venConfigIntermediadorFormFechar: function (atualizar = false, id = null, dados = null) {
        if (atualizar === true && id !== null && dados === null) {
          this.venConfigIntermediadorFormBuscaDados(id, (retorno) => { this.venConfigIntermediadorFormFechar(atualizar, id, retorno) })
        } else {
          // CHAMA A FUNÇÃO PARA FECHAR O FORMULARIO
          this.cpntFecharFormulario(atualizar, id, dados)

          // VERIFICA SE DEVE MUDAR A ROTA DO VUE
          if (this.$route.name === 'venda_config_intermediador_form') {
            this.$router.push({ name: 'venda_config_intermediador', params: {} })
          }
        }
      }
    },
    computed: {
      venConfigIntermediadorFormSubEspecieDisabled: function () {
        return [ '', null, undefined ].indexOf(this.campos.id_especie.value) !== -1 || [ '', null, undefined ].indexOf(this.campos.id_especie.value.id) !== -1
      },
      venConfigIntermediadorFormMostrarNome: function () {
        return typeof this.cpntId !== 'object' || this.cpntId.length === 1
      },
      venConfigIntermediadorFormTituloDialog: function () {
        return this.campos.nome.valueIni
      } 
    }
  }
</script>
